import classNames from "classnames";
import { forwardRef } from "react";
import styles from "./index.module.css";

interface SectionProps {
  title: string;
  id?: string;
  extra?: React.ReactNode;
  className?: string;
}

export const Section = forwardRef<
  HTMLElement,
  React.PropsWithChildren<SectionProps>
>((props, ref) => {
  const { title, children, id, extra, className } = props;
  return (
    <section
      ref={ref}
      id={id}
      className={classNames(
        "w-full mx-auto text-text-primary mb-[60px]",
        styles.section,
        className
      )}
    >
      <div className="flex items-center mb-5">
        <h1 className="text-2xl font-bold">{title}</h1>
        {extra}
      </div>
      {children}
    </section>
  );
});

Section.displayName = "Section";
